import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { CustomerService, Customer } from 'src/app/core/services/customer.service';
import { OrderService } from 'src/app/core/services/order.service';
import { Plan, PlanService } from 'src/app/core/services/plan.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrl: './detail.component.scss'
})
export class DetailComponent {

  customer: any = {};
  customerId: string = '';
  loading: boolean = false;
  totalRecords = 0;
  rows = 10;
  orders: any = [];
  // editingCustomer: Customer | null = null;
  modalRef!: NgbModalRef;
  paymentType: any = ['COD', 'Online'];
  selectedPaymentMode: string = 'COD';
  error = '';
  plans: any = [];
  selectedPlan: any = '';
  planNote: string = '';



  constructor(private customerService: CustomerService, private activatedRoute: ActivatedRoute, private modalService: NgbModal,
    private router: Router, private orderService: OrderService, private toastService: ToastService, private fb: FormBuilder,
    private planService: PlanService,) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.customerId = params?.customerId
      if (this.customerId) {
        this.getCustomerDetail();
      }
    });
  }

  getCustomerDetail() {
    this.loading = true;
    this.customerService.getCustomerDetail(this.customerId).subscribe((res: any) => {
      this.customer = res;
      this.loading = false;
    }, () => {
      this.loading = false;
    })
  }

  loadOrders(event: LazyLoadEvent) {
    this.loading = true;
    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    // let startDate: string | null = null;
    // let endDate: string | null = null;

    // if (this.rangeDates && this.rangeDates.length === 2) {
    //   startDate = this.formatDate(this.rangeDates[0]);
    //   endDate = this.formatDate(this.rangeDates[1]);
    // }

    const queryParams = {
      page: page,
      limit: rows,
      customerId: this.customerId
      // search: this.searchText,
      // orderId: this.orderId,
      // status: this.selectedStatus,
      // startDate: startDate,
      // endDate: endDate
    };
    this.orderService.getOrders(queryParams).subscribe({
      next: (res: any) => {
        this.loading = false
        this.orders = res?.data || res;
        this.totalRecords = res?.totalCount || 0;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  goBack() {
    this.router.navigate([`/customers`], {
    });
  }

  openEdit(customer: Customer, content: any) {
    this.modalRef = this.modalService.open(content, { size: 'lg' });
    this.loadPlans();
  }


  CreatePlan() {
    const plan = {
      customerId: this.customerId,
      planId: this.selectedPlan?._id,
      amount: this.selectedPlan?.price,
      planName: this.selectedPlan.name,
      currency: "INR",
      paymentMethod: this.selectedPaymentMode,
      transactionId: this.generateTransactionId(),
      notes: this.planNote
    }
    this.orderService.createOrder(plan).subscribe((res: any) => {
      this.loadOrders({});
      this.modalRef.close();
      this.toastService.showToaster(
        "Upgrade Plan",
        "Your plan has been upgraded successfully.",
        "success"
      );
    },
      () => { });
  }

  generateTransactionId(): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    const timePart = Date.now().toString(36).toUpperCase();
    const randomPart = Array.from(
      crypto.getRandomValues(new Uint8Array(10)),
      x => chars[x % chars.length]
    ).join('');

    return `TXN-${(timePart + randomPart).slice(0, 10)}`;
  }

  cancelEdit() {
    if (this.modalRef) this.modalRef.dismiss();
    // this.editingCustomer = null;
  }
  isEnable: boolean = false;

  onChangePlan(plan: any) {
    this.selectedPlan = plan;
    this.isEnable = true
    console.log(this.selectedPlan);
  }

  loadPlans() {
    this.loading = true;
    this.error = '';
    this.planService.getPlans().subscribe(
      (data: Plan[]) => {
        this.plans = data;
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

}
